import axios, { AxiosInstance } from 'axios';

/**
 * Payment Api Class
 */
class PaymentApi {
  private static _instance: PaymentApi = new PaymentApi();

  public _api: AxiosInstance;

  constructor() {
    if (PaymentApi._instance) {
      throw new Error('Error: Instantiation failed: Use PaymentApi.getInstance() instead of new.');
    }
    this._api = axios.create({
      baseURL: process.env.NEXT_PUBLIC_PAYMENT_API_ENDPOINT,
      timeout: 15000,
    });
    PaymentApi._instance = this;
  }

  public static getInstance(): PaymentApi {
    if (!this._instance) {
      this._instance = new PaymentApi();
    }
    return PaymentApi._instance;
  }

  public static api(): AxiosInstance {
    return PaymentApi._instance._api;
  }

  public setToken(token: string): void {
    this._api = axios.create({
      baseURL: process.env.NEXT_PUBLIC_PAYMENT_API_ENDPOINT,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      timeout: 15000,
    });
    PaymentApi._instance = this;
  }
}
export default PaymentApi;
